// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter as Router } from 'react-router-dom'; // NEW: Import BrowserRouter here
import './App.css';
import './index.css';

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <AuthProvider> {/* AuthProvider is the outermost context */}
            <Router> {/* Router goes inside AuthProvider */}
                <App />
            </Router>
        </AuthProvider>
    </React.StrictMode>
);
